import { PTag } from "@porsche-design-system/components-react"
import type { PTagProps } from "@porsche-design-system/components-react"
import type { NewsStatus } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage } from "react-intl"
import type { MessageDescriptor } from "react-intl"
import { newsListMessages as messages } from "./newsList.messages"

interface NewsStatusTagProps {
	status: NewsStatus
}

const statusTagConfig: Record<NewsStatus, { message: MessageDescriptor; variant: PTagProps["variant"] }> = {
	DRAFT: { message: messages.statusDraft, variant: "secondary" },
	PUBLISHED: { message: messages.statusPublished, variant: "success" },
	REVIEW: { message: messages.statusReview, variant: "info-frosted" },
}

export const NewsStatusTag = ({ status }: NewsStatusTagProps) => (
	<PTag variant={statusTagConfig[status].variant}>
		<FormattedMessage {...statusTagConfig[status].message} />
	</PTag>
)
